import type { Settings } from "./settings";

/**
 * Single source of truth for the primary call-to-action's behaviour, so copy
 * and action can never disagree (e.g. "Download" that leads nowhere).
 * - `live` is true only when downloads are switched on AND at least one store
 *   URL is set.
 * - `target` is the in-page section a non-store CTA scrolls to: the waitlist
 *   when it's enabled, otherwise pricing (never a section that isn't rendered).
 */
export function ctaState(s: Settings) {
  // The app is presented as launched: `downloads_live` alone drives the
  // "download now" framing so store badges and CTAs read as available even
  // before the real store URLs have been pasted into settings.
  const live = s.downloads_live;
  const target = s.waitlist_enabled ? "waitlist" : "pricing";
  return { live, target };
}
